import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';

import ContentWrapper from 'components/ContentWrapper';
import Paper from 'components/Paper';

const InstallIcons = ({ prop1 }) => (
  <ContentWrapper>
    <Paper topMargin={false}>
      <Grid fluid>
        <Row style={{ marginBottom: '2rem' }}>
          <Col xs={12}>
            <h3>Ohjeet työpöytäikonien asentamiseen Android ja iOS -laitteille</h3>
          </Col>
        </Row>
        <Row style={{ marginBottom: '2rem' }}>
          <Col xs={3}>
            <h4>Android</h4>
          </Col>
          <Col xs={9}>
            <ol style={{ fontSize: '1.2em' }}>
              <li>Avaa tämä sivu (https://myms.stellarq.fi/installappicons) tabletin Chrome-selaimessa</li>
              <li>
                Kun selainikkuna on auki tällä sivulla, avaa Chrome-selaimen valikko oikeasta yläkulmasta ja klikkaa
                "Lisää aloitusnäyttöön"
              </li>
              <li>My MS -ikonin tulisi ilmestyä laitteen aloitusnäyttöön</li>
            </ol>
          </Col>
        </Row>
        <Row style={{ marginBottom: '2rem' }}>
          <Col xs={3}>
            <h4>iOS</h4>
          </Col>
          <Col xs={9}>
            <ol style={{ fontSize: '1.2em' }}>
              <li>Avaa tämä sivu (https://myms.stellarq.fi/installappicons) tabletin Safari-selaimessa</li>
              <li>
                Kun selainikkuna on auki tällä sivulla, avaa Safari-selaimen jakamisen valikko (laatikko, jonka sisältö
                osoittaa nuoli ylöspäin) ja klikkaa "Lisää kotivalikkoon"
              </li>
              <li>
                My MS -ikonin tulisi ilmestyä laitteen aloitusnäyttöön (laite saattaa kysyä erillistä vielä hyväksyntää)
              </li>
            </ol>
          </Col>
        </Row>
      </Grid>
    </Paper>
  </ContentWrapper>
);

InstallIcons.propTypes = {
  prop1: PropTypes.any,
};

export default InstallIcons;
